import {
  Box,
  Grid,
  TextField,
  InputAdornment,
  Button,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import * as services from "./../../services/saleng";
import { useState, useEffect } from "react";
import { formatNumber } from "../../utils/formatNumber";
import moment from "moment";
import "moment/locale/th";
import { handleExportExcel } from "./export";

moment.locale("th");

export default function TransformTransactionsTemplate() {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [pickedFilter, setPickedFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedWeights, setSelectedWeights] = useState({});

  const [formData, setFormData] = useState({
    rawMaterialValue: "",
    leafColorIntensity: "",
    rawMaterialWeight: "",
    productValue: "",
    productColorIntensity: "",
    productWeight: "",
    productMoisture: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await services.getTransactionNonBatch();
      const data = response?.data?.data ?? [];
      setInventory(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTransactionId(null);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!selectedTransactionId) return;

    try {
      await services.updateTransaction(
        {
          materialData: {
            rawMaterialValue: Number(formData.rawMaterialValue),
            leafColorIntensity: Number(formData.leafColorIntensity),
            rawMaterialWeight: Number(formData.rawMaterialWeight),
            productValue: Number(formData.productValue),
            productColorIntensity: Number(formData.productColorIntensity),
            productWeight: Number(formData.productWeight),
            productMoisture: Number(formData.productMoisture),
          },
        },
        selectedTransactionId
      );
      alert("บันทึกเรียบร้อย");
      handleClose();
      fetchData();
    } catch (err) {
      console.error(err);
      alert("บันทึกไม่สำเร็จ");
    }
  };
  const rows = inventory
    .slice()
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((t, index) => {
      const totalWeight = (t.items || []).reduce(
        (sum, item) => sum + (item.netWeight || 0),
        0
      );

      return {
        transactionId: t.transactionId,
        id: index + 1,
        // batch_no: t.billNumber,
        name: t.items[0].productName,
        sku: t.items[0].product.code,
        createdAt: moment(t.createdAt)
          .add(543, "year")
          .format("D MMM YYYY เวลา HH:mm"),
        createdAtDate: new Date(t.createdAt),
        pickedUpAt: t.pickedUpAt
          ? moment(t.pickedUpAt)
              .add(543, "year")
              .format("D MMM YYYY เวลา HH:mm")
          : "-",
        totalWeight: t.remainingWeight,
        farmer: t.customer.name,
        isPickedUp: t.isPickedUp,
        pickedUpCode: t.pickedUpCode || "-",
      };
    });

  const columns = [
    { field: "id", headerName: "No.", flex: 0.3 },
    { field: "name", headerName: "ชื่อสินค้า", flex: 1 },
    { field: "sku", headerName: "SKU", flex: 0.7 },
    { field: "createdAt", headerName: "วันที่รับเข้า", flex: 1 },
    { field: "totalWeight", headerName: "น้ำหนักทั้งหมด (kg)", flex: 0.5 },
    { field: "farmer", headerName: "เกษตรกร", flex: 0.7 },
    {
      field: "weightToUse",
      headerName: "น้ำหนักที่จะรวม (kg)",
      flex: 0.7,
      renderCell: (params) => {
        const maxValue = params.row.totalWeight; // remainingWeight ของ transaction
        const value = selectedWeights[params.row.transactionId] || "";

        return (
          <TextField
            size="small"
            type="number"
            value={value}
            onChange={(e) => {
              let val = Number(e.target.value);
              if (val > maxValue) val = maxValue;
              if (val < 0) val = 0;
              setSelectedWeights((prev) => ({
                ...prev,
                [params.row.transactionId]: val,
              }));
            }}
            inputProps={{
              min: 0,
              max: maxValue,
              step: 0.01,
              style: { textAlign: "center" }, // จัดข้อความตรงกลาง
            }}
            sx={{
              width: "100%", // ขยายเต็ม cell
              "& .MuiInputBase-root": {
                justifyContent: "center", // จัด field ตรงกลาง
              },
            }}
          />
        );
      },
    },
  ];

  if (loading) return <Box sx={{ p: 2 }}>Loading inventory...</Box>;
  if (error) return <Box sx={{ p: 2, color: "red" }}>Error: {error}</Box>;
  const filteredRows = rows.filter((row) => {
    // Filter by pick status
    if (pickedFilter === "picked" && !row.isPickedUp) return false;
    if (pickedFilter === "notPicked" && row.isPickedUp) return false;

    // Filter by date (createdAt)
    const rowDate = new Date(row.createdAtDate);
    if (startDate && rowDate < new Date(startDate)) return false;
    if (endDate && rowDate > new Date(endDate)) return false;

    return true;
  });
  const labels = {
    rawMaterialValue: "ค่าสารตั้งต้นก่อนออกจากคลัง",
    leafColorIntensity: "ความเข้มอ่อนของสีใบก่อนออกจากคลัง",
    rawMaterialWeight: "น้ำหนักที่ตรงตามมาตรฐาน",
    productValue: "ค่าสาร product",
    productColorIntensity: "ความเข้มอ่อนของสี product",
    productWeight: "น้ำหนักของ product",
    productMoisture: "ความชื้น product",
  };

  const handleCreateBatch = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      alert("กรุณาเลือกรายการอย่างน้อย 1 รายการ");
      return;
    }
  
    const payload = selectedRows
      .map((rowId) => {
        const tx = inventory.find((t, i) => i + 1 === rowId); 
        const weightUsed = Number(selectedWeights[tx.transactionId] || 0);
        if (weightUsed <= 0) return null;
        return { id: tx.id, weightUsed };
      })
      .filter(Boolean);
  
    if (payload.length === 0) {
      alert("กรุณากรอกน้ำหนักที่จะรวมให้ถูกต้อง");
      return;
    }
      const totalWeight = payload.reduce((sum, t) => sum + t.weightUsed, 0);
    const target = 1100;
    const tolerance = 0.009 * target; 
    if (totalWeight < target - tolerance || totalWeight > target + tolerance) {
      const confirmCreate = window.confirm(
        `น้ำหนักรวมไม่อยู่ในช่วง +-0.9%ของ 1,100\n\nคุณต้องการสร้าง Batch ต่อหรือไม่?`
      );
      if (!confirmCreate) return;
    }
    try {
      await services.createCustomBatch({ transactions: payload });
      alert("✅ สร้าง Batch สำเร็จ");
      setSelectedWeights({});
      fetchData();
    } catch (err) {
      console.error("Error creating batch:", err);
      alert("❌ สร้าง Batch ไม่สำเร็จ");
    }
  };
  

  return (
    <Box p={2}>
      <AppBreadcrumbs />

      {/* Search & Button */}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="flex-start"
        sx={{ my: 1 }}
      >
        {/* Search */}
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            fullWidth
            placeholder="ค้นหารายละเอียด"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            size="small"
          />
        </Grid>

        {/* สถานะเบิก */}
        <Grid item xs={6} sm={2} md={2}>
          <TextField
            select
            label="สถานะเบิก"
            value={pickedFilter}
            onChange={(e) => setPickedFilter(e.target.value)}
            SelectProps={{ native: true }}
            size="small"
            fullWidth
          >
            <option value="all">ทั้งหมด</option>
            <option value="picked">เบิกแล้ว</option>
            <option value="notPicked">ยังไม่เบิก</option>
          </TextField>
        </Grid>

        {/* วันที่เริ่มต้น */}
        <Grid item xs={6} sm={2} md={2}>
          <TextField
            label="วันที่รับเข้าเริ่มต้น"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            fullWidth
          />
        </Grid>

        {/* วันที่สิ้นสุด */}
        <Grid item xs={6} sm={2} md={2}>
          <TextField
            label="วันที่รับเข้าสิ้นสุด"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            fullWidth
          />
        </Grid>

        {/* ปุ่มรีเฟรช */}
        <Grid item xs={6} sm={1} md={1}>
          <Button
            variant="contained"
            onClick={() => fetchData()}
            size="small"
            fullWidth
          >
            รีเฟรช
          </Button>
        </Grid>
      </Grid>

      {/* DataGrid */}
      <Paper sx={{ mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end", // ชิดขวา
            mb: 2, // ช่องว่างใต้ปุ่ม
          }}
        >
          <Button
            variant="contained"
            color="success"
            disabled={!selectedRows || selectedRows.length === 0}
            onClick={handleCreateBatch}
          >
            ✅ สร้าง Batch จากรายการที่เลือก
          </Button>
        </Box>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={filteredRows.filter((row) =>
              row.farmer.toLowerCase().includes(search.toLowerCase())
            )}
            checkboxSelection
            onRowSelectionModelChange={(ids) => setSelectedRows(ids)}
            columns={columns}
            loading={loading}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "ไม่พบข้อมูล",
            }}
          />
        </div>

        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>กรอกข้อมูล Material</DialogTitle>
          <DialogContent dividers>
            {Object.keys(formData)
              .filter((key) => {
                if (
                  [
                    "productValue",
                    "productColorIntensity",
                    "productWeight",
                    "productMoisture",
                  ].includes(key)
                ) {
                  const selectedRow = inventory.find(
                    (t) => t.transactionId === selectedTransactionId
                  );
                  return selectedRow?.isPickedUp;
                }
                return true; // field อื่น ๆ แสดงปกติ
              })
              .map((key) => (
                <TextField
                  key={key}
                  margin="dense"
                  label={labels[key]}
                  name={key}
                  type="number"
                  fullWidth
                  value={formData[key]}
                  onChange={handleChange}
                />
              ))}
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}>ยกเลิก</Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              บันทึก
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
}
